<template>
	<div>
		<az-toolbar>
			<template #simpleSearch>
				<az-search
					class="advanced-search-pedido"
					:filter="filtro"
					v-az-auth="permissoes.ataListar"
					simple-search-placeholder="Busque por N° Pedido, N° Processo ou N° Ata"
					@simple-search="buscar"
					ref="componenteAzSearch"
					@remove-filter="removerFiltros"
					@advanced-search="buscar"
					@clear="limparBusca"
				>
					<template #search-items>
						<az-search-item>
							<label-personalizado nome-campo="Atividade" class="mb-0"></label-personalizado>
							<v-autocomplete
								placeholder="Selecione a atividade do pedido"
								clearable
								outlined
								dense
								:items="atividadesPedido"
								item-text="nomeAtividade"
								item-value="idAtividade"
								@change="onAtividadePedidoChange"
								v-model="atividadePedidoSelecionada"
							></v-autocomplete>
						</az-search-item>
						<az-search-item>
							<label-personalizado nome-campo="Órgão"></label-personalizado>
							<v-autocomplete
								id="combo-autocomplete-pedidos"
								v-model="filtroInterno.siglaOrgao.value"
								name="Orgao"
								outlined
								dense
								clearable
								:items="listaOrgaos"
								placeholder="Selecione o órgão"
								class="pt-0"
								item-value="siglaOrgao"
								item-text="siglaDescricao"
								@change="onOrgaoSelecionado"
							></v-autocomplete>
						</az-search-item>
					</template>
				</az-search>
			</template>
		</az-toolbar>
		<az-container class="listagem">
			<pedido-aba-listagem
				:itens="datasource"
				:total-paginas="totalPaginas"
				:total-itens="totalItens"
				:paginacao="paginacao"
				@paginar="setPaginacaoListagem"
				@resetar-page="resetarPaginaItemListagem()"
			></pedido-aba-listagem>
		</az-container>
	</div>
</template>

<script>
import { actionTypes } from '@/core/constants'
import { mapState } from 'vuex'
import _ from 'lodash'
import mutationTypes from '@/core/constants/mutation-types'
import permissoesMixin from '@/views/mixins/permissoes-mixin'
import PedidoAbaListagem from '@/views/pages/pedido/listagem/PedidoAbaListagem.vue'
import LabelPersonalizado from '@/views/components/LabelPersonalizado.vue'

export default {
	name: 'pedido-aba-view',
	components: {
		LabelPersonalizado,
		PedidoAbaListagem,
	},
	mixins: [permissoesMixin],
	data() {
		return {
			datasource: [],
			totalPaginas: 0,
			tabs: [],
			totalItens: 0,
			filtroInterno: this.getFiltros(),
			paginacao: this.$store.state.processoUtilizacao.paginacao,
			quantidadeAdesoes: 0,
			listaOrgaos: [],
			atividadesPedido: [],
			atividadePedidoSelecionada: null,
			idOrgaoSelecionado: null,
			isComponenteAtivo: true,
		}
	},
	computed: {
		...mapState({
			filtro: (state) => state.pedido.filtro,
			pedido: (state) => state.pedido,
		}),
	},
	async mounted() {
		this.$store.commit(mutationTypes.PEDIDO.RESET_INFORMACOES)
		await this.carregarPedidos()
		await this.buscarOrgaos()
		await this.buscarAtividades()
		this.forcarExibirFiltrosAvancados()
	},
	beforeDestroy() {
		this.isComponenteAtivo = false
	},
	methods: {
		getFiltros() {
			return _.cloneDeep(this.$store.state.pedido.filtro)
		},
		removerFiltros: async function (propriedade) {
			if (propriedade === 'atividadePedido') this.removerCampoAtividadePedidoDoFiltro()

			if (propriedade === 'siglaOrgao') {
				this.$store.commit(mutationTypes.PEDIDO.SET_ID_ORGAO_ABA, null)
				this.pedido.idOrgao.value = null
			}

			if (this.filtro[propriedade]) {
				this.filtro[propriedade].value = this.filtro[propriedade].default
				this.filtroInterno[propriedade].value = this.filtroInterno[propriedade].default
			}
			await this.carregarPedidos()
		},
		async buscar(searchText) {
			if (searchText) this.filtro.numeroPedidoOuNumeroProcessoOuNumeroAta.value = searchText.trim()
			this.filtro.siglaOrgao.value = this.filtroInterno.siglaOrgao.value
			const payload = { idOrgao: this.idOrgaoSelecionado }
			this.setAtividadeNaState()
			this.resetarPaginaItemListagem()
			await this.carregarPedidos(payload)
		},
		async buscarOrgaos() {
			const orgaos = await this.$store.dispatch(actionTypes.PEDIDO.BUSCAR_PEDIDO_ORGAOS)
			this.listaOrgaos = orgaos.itens
		},
		async buscarAtividades() {
			let { itens } = await this.$store.dispatch(actionTypes.ATA.BUSCAR_ATIVIDADES_FILTRO)
			this.atividadesPedido = itens[0].atividadesPedido
		},
		async carregarPedidos(payload) {
			const retorno = await this.$store.dispatch(actionTypes.PEDIDO.BUSCAR_PEDIDO_POR_FILTRO, payload)
			this.totalPaginas = retorno.totalPages
			this.totalItens = retorno.totalElements
			this.datasource = retorno.itens
		},
		setPaginacaoListagem(paginacao) {
			this.$store.commit(mutationTypes.PEDIDO.SET_PAGINACAO_LISTAGEM, paginacao)
			this.carregarPedidos()
		},
		limparBusca() {
			this.$store.commit(mutationTypes.PEDIDO.LIMPAR_FILTRO_LISTAGEM)
			this.filtroInterno = this.getFiltros()
			if (!this.filtroInterno.siglaOrgao.value) {
				this.$store.commit(mutationTypes.PEDIDO.RESET_ID_ORGAO_ABA)
			}
			this.removerCampoAtividadePedidoDoFiltro()
			this.limparCampoOrgaoDaBusca()
			this.carregarPedidos()
		},
		resetarPaginaItemListagem() {
			this.$store.commit(mutationTypes.PEDIDO.RESETAR_PAGINA_LISTAGEM)
		},
		temAtividadePedidoSelecionado() {
			if (this.atividadePedidoSelecionada) return true
			this.limparCampoAtividadePedidoDaBusca()
			return false
		},
		onAtividadePedidoChange(idAtv) {
			this.atividadePedidoSelecionada =
				this.atividadesPedido.find((atividade) => atividade.idAtividade === idAtv) || null
		},
		limparCampoAtividadePedidoDaBusca() {
			this.filtro.atividadePedido.value = this.$store.state.pedido.idAtividadePedido.value = null
		},
		limparCampoOrgaoDaBusca() {
			this.$store.commit(mutationTypes.PEDIDO.RESET_ID_ORGAO_ABA)
			this.idOrgaoSelecionado = null
		},
		removerCampoAtividadePedidoDoFiltro() {
			this.limparCampoAtividadePedidoDaBusca()
			this.atividadePedidoSelecionada = null
		},
		setAtividadeNaState() {
			let temAtividadePedido = this.temAtividadePedidoSelecionado()

			if (temAtividadePedido) {
				this.filtro.atividadePedido.value = this.atividadePedidoSelecionada.nomeAtividade
				this.$store.state.pedido.idAtividadePedido.value = this.atividadePedidoSelecionada.idAtividade
			}
		},
		onOrgaoSelecionado(selectedSigla) {
			const orgao = this.listaOrgaos.find((item) => item.siglaOrgao === selectedSigla)
			if (orgao) {
				this.$store.commit(mutationTypes.PEDIDO.SET_ID_ORGAO_ABA, orgao.idOrgao)
			} else {
				this.$store.commit(mutationTypes.PEDIDO.SET_ID_ORGAO_ABA, null)
			}
		},
		forcarExibirFiltrosAvancados() {
			if (!this.isComponenteAtivo) return
			let componenteBusca = this.$refs.componenteAzSearch
			componenteBusca.hasAdvancedSearchItems = true
		},
	},
}
</script>

<style lang="stylus">

@media screen and (min-width: 750px)
	.input-search
		width 350px !important

.advanced-search-pedido .simple-search .input-search
	overflow-x scroll
	scrollbar-width: none
</style>
